import {
    patchState,
    signalStore,
    withComputed,
    withHooks,
    withMethods,
    withState,
} from "@ngrx/signals";
import {
    setError,
    setFulfilled,
    setPending,
    withRequestStatus,
} from "../extensions/request-status.feature";
import { computed, inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { filter, pipe, switchMap, tap } from "rxjs";
import { withRouteParams } from "../extensions/route-params.feature";
import { QuestTemplatesStore } from "./quest-templates.store";
import { ApiQuestsService } from "../../services/api-quests.service";
import { setEntity } from "@ngrx/signals/entities";

export type QuestTemplateStore = InstanceType<typeof QuestTemplateStore>;

export const QuestTemplateStore = signalStore(
    { protectedState: false },
    withState<{ templateId: number }>({
        templateId: 0,
    }),
    withRouteParams({ templateId: (param) => Number(param) }),
    withRequestStatus(),
    withComputed(
        ({ templateId: templateId }, questTemplatesStore = inject(QuestTemplatesStore)) => ({
            template: computed(() =>
                templateId() ? questTemplatesStore.entityMap()[templateId()] : null,
            ),
        }),
    ),
    withMethods(
        (
            store,
            questTemplatesStore = inject(QuestTemplatesStore),
            apiQuestsService = inject(ApiQuestsService),
        ) => ({
            loadTemplate: rxMethod<number>(
                pipe(
                    filter((id) => !!id && !store.template()),
                    tap(() => patchState(store, setPending())),
                    switchMap((id) => {
                        return apiQuestsService.getTemplate(id).pipe(
                            tap({
                                next: (template) => {
                                    patchState(store, setFulfilled());
                                    patchState(questTemplatesStore, setEntity(template));
                                },
                                error: (error) => patchState(store, setError(error.error.error)),
                            }),
                        );
                    }),
                ),
            ),
        }),
    ),
    withHooks({
        onInit({ loadTemplate, templateId }) {
            loadTemplate(templateId);
        },
    }),
);
